import type { ReactNode } from 'react';
import React from 'react';

import * as styles from '../styles/Footer.styles';

export interface FooterProps {
  children: ReactNode;
}

export const Footer = ({ children }: FooterProps) => (
  <div css={styles.footerWrapper}>{children}</div>
);
